import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface SettingsCardProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
}

/** One card of the company page: an icon, a heading, and its fields. */
export function SettingsCard({ icon: Icon, title, children }: SettingsCardProps) {
  return (
    <section aria-label={title} className="rounded-lg border border-line bg-surface p-6">
      <div className="mb-5 flex items-center gap-3">
        <div className="grid size-9 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20">
          <Icon className="size-4.5" />
        </div>
        <h2 className="text-base font-semibold text-fg">{title}</h2>
      </div>
      {children}
    </section>
  );
}
